import { Disc3 } from "lucide-react";

/* The Rhythm Report rating — homage to golden-era music magazines:
   5 spins = CLASSIC. score (out of 10) maps to spins (out of 5). */

export default function SpinRating({ score, size = 16, showValue = true, mono = false }) {
  const spins = Math.max(0, Math.min(5, (parseFloat(score) || 0) / 2));
  const full = Math.floor(spins);
  const half = spins - full >= 0.25 && spins - full < 0.75;
  const count = Math.round(spins);
  const isClassic = spins >= 4.75;

  return (
    <span
      data-testid={`spin-rating-${count}`}
      className={`inline-flex items-center gap-1.5 ${mono ? "font-rhythm-mono text-[10px] uppercase tracking-[0.14em]" : "text-sm font-bold"}`}
      title={`${spins.toFixed(1)} spins out of 5`}
    >
      {[0, 1, 2, 3, 4].map((i) => {
        const on = i < full;
        const isHalf = i === full && half;
        return (
          <Disc3
            key={i}
            style={{ width: size, height: size }}
            className={on || isHalf ? "text-[#F3F1ED]" : "text-white/25"}
            strokeWidth={on ? 2.4 : 1.6}
            opacity={isHalf ? 0.55 : 1}
          />
        );
      })}
      {showValue && (
        <span className="text-white/80">
          {spins.toFixed(1)} spins{isClassic ? " · CLASSIC" : ""}
        </span>
      )}
    </span>
  );
}
